import Font from "@/src/components/base/Font";
import { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import { WordStyling } from "@/src/utils/types/landingpage";

export default function CardLayanan({
  src,
  id,
  field,
  desc,
  listWordStyling,
  transitionDelay,
}: {
  src?: string;
  id?: string;
  field?: string;
  desc?: string;
  listWordStyling?: WordStyling[];
  transitionDelay?: string;
}) {
  const containerRef = useRef(null);

  const callbackFn: IntersectionObserverCallback = (
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
  ) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(styles["visible"]);
        observer.unobserve(entry.target)
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFn);
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [containerRef]);

  return (
    <div
      ref={containerRef}
      id={id}
      className={styles["service-box"]}
      style={{
        transitionDelay: transitionDelay
      }}
    >
      <img
        src={src}
        width={65}
        // height={100}
      />
      <Font
        fontStyle={
          field && ["machine learning", "advance ai"]?.includes(field.toLowerCase())
            ? "italic"
            : "default"
        }
        variant="subtitle-6-bold"
        color="black"
      >
        {field}
      </Font>
      <Font variant="subtitle-4-medium" color="dark10" listWordStyling={listWordStyling} >
        {desc}
      </Font>
    </div>
  );
}
